import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'

import validationMessagesEn from 'vee-validate/dist/locale/en'
import validationMessagesEs from 'vee-validate/dist/locale/es'

Vue.use(VueI18n)

const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
    validations: validationMessagesEn.messages,
  },
  es: {
    ...require('@/locales/es.json'),
    $vuetify: es,
    validations: validationMessagesEs.messages,
  },
}
export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'es',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es',
  messages,
})
